/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

export const hasIntersection = (arr1: any[], arr2: any[]) =>
  arr1.some(element => arr2.includes(element))

export const addThousandSeparator = (num: number): string =>
  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export const delay = (wait: number): Promise<void> =>
  new Promise(resolve => setTimeout(resolve, wait))

export const debounce = <A extends any[] = any[]>(
  func: (...args: A) => void,
  wait = 300
): ((...args: A) => void) => {
  let timer: number
  return (...args: A) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func(...args)
    }, wait)
  }
}

export const throttle = <A extends any[] = any[]>(
  func: (...args: A) => void,
  limit = 500
): ((...args: A) => void) => {
  let inThrottle = false
  return function (...args: A) {
    if (!inThrottle) {
      func(...args)
      inThrottle = true
      setTimeout(() => {
        inThrottle = false
      }, limit)
    }
  }
}

export const isAsciiOrExtended = (text: string) =>
  [...text].every(char => (char.codePointAt(0) || 256) < 256)
